// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"icons-module--wrapper--1wWBU"};